import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/common/Reveal";
import { SectionLabel } from "@/components/common/SectionLabel";
import { ContentCard } from "@/components/content/ContentCard";
import { MEDIA } from "@/config/media";

const previewItems = [
  { category: "Match Commentary", image: MEDIA.contentThumbnails["Match Commentary"] },
  { category: "Interviews", image: MEDIA.contentThumbnails.Interviews },
  { category: "Highlights", image: MEDIA.contentThumbnails.Highlights },
];

export const ContentPreview = () => (
  <section data-testid="content-preview-section" className="bg-white py-24">
    <div className="mx-auto max-w-7xl px-6 lg:px-12">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <Reveal>
          <SectionLabel index="03" title="Content Hub" />
          <h2 className="mt-3 font-heading text-4xl uppercase text-brand-black sm:text-5xl">Latest Content</h2>
        </Reveal>
        <Reveal delay={0.1}>
          <Link to="/content" data-testid="content-preview-view-all" className="inline-flex items-center gap-2 font-subheading text-sm font-semibold uppercase tracking-wide text-brand-purple hover:text-brand-black transition-colors">
            Browse The Content Hub <ArrowUpRight className="h-4 w-4" />
          </Link>
        </Reveal>
      </div>

      <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {previewItems.map((item, i) => (
          <Reveal key={item.category} delay={i * 0.08}>
            <ContentCard item={item} />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
